import axios from 'axios'
import authentication from './store/authentication'

class Api {
  login (user, password) {
    return new Promise(
      // Resolver-Funktion kann den Promise sowohl auflösen als auch verwerfen
      // reject the promise
      function (resolve, reject) {
        axios.post(process.env.API_URI + 'api.php?function=login',
          {
            user: user,
            password: password
          }
        ).then(function (response) {
          if (response.data && response.status === 200) {
            localStorage.setItem('loginData', JSON.stringify(response.data))
            resolve(response)
          }
        }).catch(function (error) {
          if (error.response) {
            // console.log(error.response.data)
            // console.log(error.response.status)
            // console.log(error.response.headers)
            reject('FAILD')
          }
          /* else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message)
                    }*/
        })
      }
    )
  }

  logout () {
    localStorage.removeItem('loginData')
  }

  getLoginData () {
    let data = localStorage.getItem('loginData')
    if (data !== null && typeof data !== 'undefined') {
      try {
        return JSON.parse(data)
      } catch (error) {
        return false
      }
    }
    return false
  }

  isLoggedIn () {
    let data = this.getLoginData()

    if (data && data.token) {
      return true
    }
    return false
  }

  getToken () {
    let data = this.getLoginData()

    if (data && data.token) {
      return data.token
    }
    return ''
  }

  getAllProjects () {
    let token = this.getToken()
    let _that = this

    return new Promise(
      function (resolve, reject) {

        axios.get(process.env.API_URI + 'api.php?function=getAllProjects',
          {'headers': {'X-Authorization': token}}
        )
          .then(function (response) {
              if (response.data && response.status === 200) {
                resolve(response.data)
              }
            }
          )
          .catch(function (error) {
              if (error.response) {
                if (error.response.status === 401) {
                  _that.logout()
                  reject('UNAUTHORIZED')
                }
              }
              reject('FAILD')
            }
          )
      }
    )
  }

  getProjectStatus (projektIdentifier) {
    let token = this.getToken()
    let _that = this

    return new Promise(
      function (resolve, reject) {

        axios.get(process.env.API_URI + 'api.php?function=getProjectStatus&projectIdentifier=' + projektIdentifier,
          {'headers': {'X-Authorization': token}}
        )
          .then(function (response) {
              if (response.data && response.status === 200) {
                resolve(response.data)
              }
            }
          )
          .catch(function (error) {
              if (error.response) {
                if (error.response.status === 401) {
                  _that.logout()
                  reject('UNAUTHORIZED')
                }
              }
              reject('FAILD')
            }
          )
      }
    )
  }

  updateCurrent (projektIdentifier) {
    let token = this.getToken()
    let _that = this

    return new Promise(
      function (resolve, reject) {

        axios.get(process.env.API_URI + 'api.php?function=updateCurrent&projectIdentifier=' + projektIdentifier,
          {'headers': {'X-Authorization': token}}
        )
          .then(function (response) {
              if (response.data && response.status === 200) {
                resolve(response.data)
              }
            }
          )
          .catch(function (error) {
              if (error.response) {
                if (error.response.status === 401) {
                  _that.logout()
                  reject('UNAUTHORIZED')
                }
              }
              reject('FAILD')
            }
          )
      }
    )
  }

  updateNext (projektIdentifier) {
    let token = this.getToken()
    let _that = this

    return new Promise(
      function (resolve, reject) {

        axios.get(process.env.API_URI + 'api.php?function=updateNext&projectIdentifier=' + projektIdentifier,
          {'headers': {'X-Authorization': token}}
        )
          .then(function (response) {
              if (response.data && response.status === 200) {
                resolve(response.data)
              }
            }
          )
          .catch(function (error) {
              if (error.response) {
                if (error.response.status === 401) {
                  _that.logout()
                  reject('UNAUTHORIZED')
                }
              }
              reject('FAILD')
            }
          )
      }
    )
  }

  deactivateMaintenanceMode (projektIdentifier) {
    let token = this.getToken()
    let _that = this

    return new Promise(
      function (resolve, reject) {

        axios.get(process.env.API_URI + 'api.php?function=deactivateMaintenanceMode&projectIdentifier=' + projektIdentifier,
          {'headers': {'X-Authorization': token}}
        )
          .then(function (response) {
              if (response.data && response.status === 200) {
                resolve(response.data)
              }
            }
          )
          .catch(function (error) {
              if (error.response) {
                if (error.response.status === 401) {
                  _that.logout()
                  reject('UNAUTHORIZED')
                }
              }
              reject('FAILD')
            }
          )
      }
    )
  }

  deactivateCronPause (projektIdentifier) {
    let token = this.getToken()
    let _that = this

    return new Promise(
      function (resolve, reject) {

        axios.get(process.env.API_URI + 'api.php?function=deactivateCronPause&projectIdentifier=' + projektIdentifier,
          {'headers': {'X-Authorization': token}}
        )
          .then(function (response) {
              if (response.data && response.status === 200) {
                resolve(response.data)
              }
            }
          )
          .catch(function (error) {
              if (error.response) {
                if (error.response.status === 401) {
                  _that.logout()
                  reject('UNAUTHORIZED')
                }
              }
              reject('FAILD')
            }
          )
      }
    )
  }

  getLogs () {
    let token = this.getToken()
    let _that = this

    return new Promise(
      function (resolve, reject) {

        axios.get(process.env.API_URI + 'api.php?function=getLogs',
          {'headers': {'X-Authorization': token}}
        )
          .then(function (response) {
              if (response.data && response.status === 200) {
                resolve(response.data)
              }
            }
          )
          .catch(function (error) {
              if (error.response) {
                if (error.response.status === 401) {
                  _that.logout()
                  reject('UNAUTHORIZED')
                }
              }
              reject('FAILD')
            }
          )
      }
    )
  }

  getReleaseBranches () {
    let token = this.getToken()
    let _that = this

    return new Promise(
      function (resolve, reject) {

        axios.get(process.env.API_URI + 'api.php?function=getReleaseBranches',
          {'headers': {'X-Authorization': token}}
        )
          .then(function (response) {
              if (response.data && response.status === 200) {
                resolve(response.data)
              }
            }
          )
          .catch(function (error) {
              if (error.response) {
                if (error.response.status === 401) {
                  _that.logout()
                  reject('UNAUTHORIZED')
                }
              }
              reject('FAILD')
            }
          )
      }
    )
  }

  getProjectKeys () {
    let token = this.getToken()
    let _that = this

    return new Promise(
      function (resolve, reject) {

        axios.get(process.env.API_URI + 'api.php?function=getProjectKeys',
          {'headers': {'X-Authorization': token}}
        )
          .then(function (response) {
              if (response.data && response.status === 200) {
                resolve(response.data)
              }
            }
          )
          .catch(function (error) {
              if (error.response) {
                if (error.response.status === 401) {
                  _that.logout()
                  reject('UNAUTHORIZED')
                }
              }
              reject('FAILD')
            }
          )
      }
    )
  }

  getChanges (project, from, to) {
    let token = this.getToken()
    let _that = this

    return new Promise(
      function (resolve, reject) {

        axios.get(process.env.API_URI + 'api.php?function=getChanges&projectIdentifier='+project+'&from='+from+'&to='+to,
          {'headers': {'X-Authorization': token}}
        )
          .then(function (response) {
              if (response.data && response.status === 200) {
                resolve(response.data)
              }
            }
          )
          .catch(function (error) {
              if (error.response) {
                if (error.response.status === 401) {
                  _that.logout()
                  reject('UNAUTHORIZED')
                }
              }
              reject('FAILD')
            }
          )
      }
    )
  }
}

export default new Api


// WEBPACK FOOTER //
// ./src/Api.js